import script from "./Rodape.vue?vue&type=script&setup=true&lang=js"
export * from "./Rodape.vue?vue&type=script&setup=true&lang=js"

import "./Rodape.vue?vue&type=style&index=0&id=739cba20&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-739cba20"]])

export default __exports__